//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {CollapseTransition} from "@ivanv/vue-collapse-transition";
import assetUrl from "../js/components/assetUrl";
import MapElement from "./MapElement.vue";
import Swiper from "swiper";

export default {
  components: {
    CollapseTransition,
    MapElement
  },
  data() {
    return {
      points: [
        {
          x: 458,
          y: 136,
          country: 'country.russia.name',
          offices: 'country.russia.offices',
          isWorldMap: false,
          mapPoints: [
            {
              x: 482,
              y: 297,
              name: "country.russia.cities.vladivostok"
            },
            {
              x: 235,
              y: 235,
              name: "country.russia.cities.novosibirsk"
            },
            {
              x: 141,
              y: 191,
              name: "country.russia.cities.ekb"
            },
            {
              x: 89,
              y: 189,
              name: "country.russia.cities.samara"
            },
            {
              x: 84,
              y: 149,
              name: "country.russia.cities.nijnov"
            },
            {
              x: 64,
              y: 129,
              name: "country.russia.cities.moscow"
            },
            {
              x: 76,
              y: 86,
              name: "country.russia.cities.spb"
            },
            {
              x: 21,
              y: 177,
              name: "country.russia.cities.don"
            },
            {
              x: 6,
              y: 185,
              name: "country.russia.cities.krasnodar"
            },
          ]
        },
        {
          x: 482,
          y: 280,
          country: 'country.turkey.name',
          offices: 'country.turkey.offices',
          isWorldMap: true,
          mapPoints: [
            {
              x: 312,
              y: 120,
              name: "country.turkey.cities.stambul"
            },
          ]
        },
        {
          x: 264,
          y: 318,
          country: 'country.dubai.name',
          offices: 'country.dubai.offices',
          isWorldMap: true,
          mapPoints: [
            {
              x: 358,
              y: 156,
              name: "country.dubai.cities.dubai"
            },
          ]
        },
        {
          x: 284,
          y: 318,
          country: 'country.dominican.name',
          offices: 'country.dominican.offices',
          isWorldMap: true,
          mapPoints: [
            {
              x: 155,
              y: 165,
              name: "country.dominican.cities.santo"
            },
          ]
        },
        {
          x: 448,
          y: 196,
          country: 'country.ukraine.name',
          offices: 'country.ukraine.offices',
          isWorldMap: true,
          mapPoints: [
            {
              x: 316,
              y: 101,
              name: "country.ukraine.cities.kiev"
            },
          ]
        },
      ],
      imgBaseSize: {
        russianMap: {
          x: 560,
          y: 310,
        },
        worldMap: {
          x: 572,
          y: 317,
        }
      },
      activePoint: null,
      swiper: [],
      isMounted: false,
    }
  },
  created() {
    this.points.forEach((el, key) => {
      const baseSize = el.isWorldMap ? this.imgBaseSize.worldMap : this.imgBaseSize.russianMap;
      el.mapPoints.forEach((city, cityKey) => {
        this.$set(city, 'percentCoordinate', {
          x: city.x * 100 / baseSize.x,
          y: city.y * 100 / baseSize.y,
        });
        this.$set(city, 'id', cityKey);
        this.$set(city, 'isActive', false);
      });
      this.$set(el, 'id', key);
      this.$set(el, 'isActive', false);

    });

    if (this.points.length > 0) {
      this.activatePoint(this.points[0]);
    }
  },
  mounted() {
    this.isMounted = true;
    this.$nextTick(function () {
      this.points.forEach((point) => {
        const swiperContainer = this.$refs[`mapSwiperContainer${point.id}`];
        this.$set(this.swiper, point.id, new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 20,
          allowTouchMove: true,
        }))
      });

    });
  },
  computed: {
    pointStyle() {
      return (point) => {
        return {
          left: `${point.percentCoordinate.x}%`,
          top: `${point.percentCoordinate.y}%`,
        }
      }
    },
    mapUrl() {
      if (this.activePoint && this.activePoint.isWorldMap) {
        return assetUrl('../img/mapWorld.png');
      }
      return assetUrl('../img/n/map.svg');
    },
    canSwipeSlide() {
      return (point, direction) => {
        if (this.isMounted && this.swiper[point.id]) {
          const currentIndex = this.swiper[point.id].realIndex;
          if (direction > 0) {
            return currentIndex + 1 < this.swiper[point.id].slides.length;
          } else {
            return currentIndex !== 0;
          }
        }
        return false;
      }
    },
  },
  methods: {
    imgDebug(e) {
      console.log('qwe', e);
      var rect = e.target.getBoundingClientRect();
      var x = e.clientX - rect.left; //x position within the element.
      var y = e.clientY - rect.top;  //y position within the element.
      console.log("Left? : " + x + " ; Top? : " + y + ".");
    },
    drawPoints(points) {

    },
    getCities() {
      let cities = [];
      if (this.activePoint) {
        let activeCountries = this.points.filter((el) => {
          return el.isWorldMap === this.activePoint.isWorldMap;
        });

        activeCountries.forEach((country) => {
          cities.push.apply(cities, country.mapPoints);
        });
      }
      return cities;
    },
    activatePoint(point) {
      if (this.activePoint) {
        this.activePoint.isActive = false;
      }
      point.isActive = true;
      this.activePoint = point;
    },
    goToSlide(point, slideNumber) {
      this.swiper[point.id].slideTo(slideNumber);
    },
    firePreviousSlide(point) {
      const currentIndex = this.swiper[point.id].realIndex;
      let nextIndex = currentIndex - 1;
      if (nextIndex < 0) {
        return;
      }
      this.goToSlide(point, nextIndex);
    },
    fireNextSlide(point) {
      const currentIndex = this.swiper[point.id].realIndex;
      let nextIndex = currentIndex + 1;
      if (nextIndex >= this.swiper[point.id].slides.length) {
        return;
      }
      this.goToSlide(point, nextIndex);
    },
  }
};
